import {
  GET_PROFILE
} from './constants'

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/users_controller.rb#L25
 * @return {Axios.IPromise<U>}
 */
export function getProfile () {
  return axios
    .get(GET_PROFILE, { withCredentials: true })
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./app/api/profile/profile.js